<template>
  <div class="box">
    <div class="level">
      <div class="level-left">
        <p class="title is-5">{{ title }}</p>
      </div>

      <div class="level-right columns">
        <div></div>

        <slot class="column" name="additional">
          <p class="title is-5">{{ additional }}</p>
        </slot>

        <div class="column">
          <b-tooltip label="Export report as a file">
            <b-dropdown aria-role="list" position="is-bottom-left">
              <button class="button mr-2" slot="trigger">
                <b-icon icon="download"></b-icon>
              </button>

              <b-dropdown-item @click="exportAs('xlsx')">
                .xlsx (Excel File)
              </b-dropdown-item>
            </b-dropdown>
          </b-tooltip>

          <charting-time-options
            v-if="timeFiltering"
            @submit="onNewOptionsSubmitted" :displayTypeFiltering="displayTypeFiltering"
          ></charting-time-options>
        </div>

        <button v-if="!timeFiltering" class="button" disabled>
          <b-icon icon="settings"></b-icon>
        </button>
      </div>
    </div>

    <div :style="{ minHeight: height + 'px' }">
      <slot name="chart" :time="options"></slot>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import ChartingTimeOptions from "./ChartingTimeOptions";

export default {
  components: {
    ChartingTimeOptions
  },

  props: {
    title: {
      type: String
    },

    additional: {
      type: String
    },

    timeFiltering: {
      type: Boolean,
      default: true
    },

    displayTypeFiltering: {
      type: Boolean,
      default: false
    },

    height: {
      default: 200
    }
  },

  data() {
    return {
      options: null
    };
  },

  computed: {
    firstChildChart() {
      return _.find(this.$children, child => {
        return child.dataUrl != null;
      });
    }
  },

  methods: {
    onNewOptionsSubmitted(options) {
      this.options = options;
    },

    exportAs(format) {
      window.open(
        this.firstChildChart.dataUrlWithQueryString() + `&format=${format}`,
        "_blank"
      );
    }
  }
};
</script>
